import { ReadyState } from 'react-use-websocket'

export const RECONNECT_ATTEMPTS = 120
export const RECONNECT_INTERVAL_MS = 1000
export const HEARTBEAT_INTERVAL_MS = 10000

export const CONNECTION_STATUS_LABELS: Record<ReadyState, string> = {
  [ReadyState.CONNECTING]: 'Connecting',
  [ReadyState.OPEN]: 'Open',
  [ReadyState.CLOSING]: 'Closing',
  [ReadyState.CLOSED]: 'Closed',
  [ReadyState.UNINSTANTIATED]: 'Uninstantiated',
}
